import React from 'react';
import { MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12 px-4" style={{ background: 'var(--bg-hero)' }}>
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo & Location */}
          <div className="flex flex-col items-center md:items-start gap-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-[#8FEC78] flex items-center justify-center">
                <span className="text-[#003720] font-bold text-sm">C</span>
              </div>
              <span className="font-semibold text-lg text-white">
                Crew Up
              </span>
            </div>
            <div className="flex items-center gap-1.5" style={{ color: 'rgba(255,255,255,0.5)' }}>
              <MapPin size={14} />
              <span className="text-sm">Launching Soon – South Africa</span>
            </div>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6">
            <a href="#how-it-works" className="text-sm hover:text-white transition-colors" style={{ color: 'rgba(255,255,255,0.6)' }}>
              How it Works
            </a>
            <a href="#for-businesses" className="text-sm hover:text-white transition-colors" style={{ color: 'rgba(255,255,255,0.6)' }}>
              For Businesses
            </a>
            <a href="#for-staff" className="text-sm hover:text-white transition-colors" style={{ color: 'rgba(255,255,255,0.6)' }}>
              For Staff
            </a>
            <a href="#trust" className="text-sm hover:text-white transition-colors" style={{ color: 'rgba(255,255,255,0.6)' }}>
              Trust & Safety
            </a>
          </div>

          {/* Copyright */}
          <div className="text-sm" style={{ color: 'rgba(255,255,255,0.4)' }}>
            © {currentYear} Crew Up. All rights reserved.
          </div>
        </div>

        {/* Divider */}
        <div className="mt-8 pt-6 border-t" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
          <p className="text-center text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>
            On-demand hospitality staffing for restaurants, cafés, hotels, and events.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
